<template>
  <v-card outlined tile>
    <v-app-bar
      v-if="step === 2"
      height="40"
      style="background-color: black !important"
      flat
      dark
      class="justify-center align-center"
    >
      <v-spacer></v-spacer>
      {{ $t('subOrder.scanOfAllProducts') }}
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-btn v-if="step > 1" fab small @click="updatePickPackShip()" fixed right>
      <v-icon color="primary">mdi-content-save-outline</v-icon>
    </v-btn>
    <pick-pack-ship-step1 v-if="step === 1" :sub-orders="computedSubOrders"></pick-pack-ship-step1>
    <pick-pack-ship-step2
      v-if="step === 2"
      ref="step2"
      :sub-orders="computedSubOrders"
      :saved-items-to-scan="pickPackShip && pickPackShip.items_to_scan"
    ></pick-pack-ship-step2>
    <pick-pack-ship-step3
      v-if="step === 3"
      :sub-orders="computedSubOrders"
      :types-requiring-locker="getTypeRequiringLockers()"
      @validatePreparations="updateRemainingSubOrders"
      @notUpdatedSubOrders="handleNotUpdatedSubOrdersEvent"
      @allPreparationsRemoved="openRedirectDialog()"
      @lockerSelected="updateSubOrderLocker"
    ></pick-pack-ship-step3>
    <v-bottom-navigation
      background-color="black"
      dark
      fixed
      height="40"
      :class="{ 'retracted-bottom-button': drawer && !mini && $vuetify.breakpoint.width >= 960 }"
    >
      <v-row class="justify-center align-center bin-bottom-button" @click="goToStep(step + 1)">
        <span v-if="step === 1">{{ $t('subOrder.startMyPicking') }}</span>
        <span v-if="step === 2">{{ $t('subOrder.finishMyPicking') }}</span>
        <span v-if="step === 3">{{ $t('subOrder.closeOrderPreparations') }}</span>
      </v-row>
    </v-bottom-navigation>
    <information-dialog
      v-model="notUpdatedSubOrdersDialog"
      v-if="notUpdatedSubOrdersDialog"
      :title="notUpdatedSubOrdersDialogTitle"
      :introductionSentence="notUpdatedSubOrdersDialogMessage"
      @close="closingPreparations ? $router.push({ path: '/sub-orders/waiting' }) : ''"
    >
      <template v-slot:content>
        <v-container fluid class="mb-8">
          <v-list-item dense v-for="notUpdatedSubOrder of notUpdatedSubOrders" v-bind:key="notUpdatedSubOrder[0]">
            <v-list-item-icon class="mr-1">
              <v-icon>mdi-square-medium</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-card-text class="py-0">
                {{ notUpdatedSubOrder[0] }}: {{ translateNonProcessingReasons(notUpdatedSubOrder[1]) }}
              </v-card-text>
            </v-list-item-content>
          </v-list-item>
        </v-container>
      </template>
    </information-dialog>
    <information-dialog
      v-model="redirectDialog"
      v-if="!notUpdatedSubOrdersDialog && redirectDialog"
      persistent
      :title="redirectDialogTitle"
      :introductionSentence="redirectDialogMessage"
      @close="$router.push({ path: '/sub-orders/waiting' })"
    >
      <template v-if="redirectDialogMessageBottom" v-slot:content>
        <v-card-text>{{ redirectDialogMessageBottom }}</v-card-text>
      </template>
    </information-dialog>
    <confirmation-dialog
      v-model="cancelPreparationsDialog"
      :title="$t('subOrder.confirmPreparationCancellation')"
      :text="$t('subOrder.confirmPreparationCancellationMessage')"
      @yes="validatePreparationsCancellation"
      @no="cancelPreparationsDialog = false"
    ></confirmation-dialog>
  </v-card>
</template>
<script>
  import { mapState } from 'vuex'
  import { EventBus } from '@/event-bus'
  // import ProductPositionChoiceDialog from "@/components/dialogs/ProductPositionChoiceDialog"
  import informationDialog from '@/components/dialogs/InformationDialog.vue'
  import confirmationDialog from '@/components/ConfirmationDialog.vue'
  import pickPackShipStep1 from '@/components/SubOrders/pickPackShip/pickPackShipStep1.vue'
  import pickPackShipStep2 from '@/components/SubOrders/pickPackShip/pickPackShipStep2.vue'
  import pickPackShipStep3 from '@/components/SubOrders/pickPackShip/pickPackShipStep3.vue'

  export default {
    name: 'BinSummary',
    components: {
      // ProductPositionChoiceDialog,
      informationDialog,
      confirmationDialog,
      pickPackShipStep1,
      pickPackShipStep2,
      pickPackShipStep3,
    },
    data() {
      return {
        subOrders: [],
        defaultImage: require('@/assets/img/products/product_default.png'),
        step: null,
        selected: [],
        loadingBtn: false,
        notUpdatedSubOrdersDialog: false,
        notUpdatedSubOrdersDialogTitle: null,
        notUpdatedSubOrdersDialogMessage: null,
        notUpdatedSubOrders: [],
        redirectDialog: false,
        redirectDialogTitle: null,
        redirectDialogMessage: null,
        redirectDialogMessageBottom: null,
        validatedSubOrders: [],
        fullyPreparedSubOrders: [],
        partiallyPreparedSubOrders: [],
        remainingSubOrders: [],
        showNotPreparedTooltip: [],
        cancelPreparationsDialog: false,
        closingPreparations: false,
        orderSettings: false,
        pickPackShip: null,
      }
    },
    async created() {
      if (this.$route.params.id) {
        await this.getPickPackShip()
      } else {
        this.subOrders = this.$route.params.data
        if (!Array.isArray(this.subOrders) || !this.subOrders.length) {
          await this.$router.push({ path: '/sub-orders/waiting' })
        }
        this.step = 1
      }
    },
    computed: {
      ...mapState(['drawer', 'mini', 'currentStore', 'currentStoreDetails']),
      computedSubOrders: function () {
        let subOrdersWithBins = []
        if (Array.isArray(this.subOrders)) {
          subOrdersWithBins = JSON.parse(JSON.stringify(this.subOrders))
          if (this.pickPackShip) {
            subOrdersWithBins = subOrdersWithBins.map((subOrdersWithoutBin) => {
              const PPSSubOrder = this.pickPackShip.sub_orders.find(
                (PPS) => PPS.order_id === subOrdersWithoutBin.order_id
              )
              return { ...subOrdersWithoutBin, binId: PPSSubOrder.bin_id, preparation_locker_id: PPSSubOrder.preparation_locker_id }
            })
          } else {
            for (let subOrderIndex in subOrdersWithBins) {
              subOrdersWithBins[subOrderIndex]['binId'] = parseInt(subOrderIndex) + 1
            }
          }
        }

        return subOrdersWithBins
      },
      totalNbProduct: function () {
        let totalNbProduct = 0
        for (let subOrder of this.subOrders) {
          totalNbProduct += subOrder.items.reduce((a, b) => a + b.product_quantity, 0)
        }
        return totalNbProduct
      },
      isMobile: function () {
        return this.$vuetify.breakpoint.width < 650
      },
    },
    methods: {
      getItemsToScan() {
        return this.$refs.step2.returnItemsToScan()
      },
      async goToStep(newStep) {
        if (newStep <= 3) {
          const subOrdersToDelete = this.deleteSubOrdersWithPreparationTimeoutReached()
          if (Object.keys(subOrdersToDelete).length) {
            this.openNotUpdatedSubOrdersDialog(
              Object.entries(subOrdersToDelete),
              this.$t('subOrder.preparationOrdersNotProcessed'),
              this.$t('subOrder.preparationOrdersNotProcessedMessage')
            )
          }
          if (!this.subOrders.length) {
            this.openRedirectDialog()
          } else if (this.step === 1 && newStep === 2) {
            await this.enterStep2()
          } else if (this.step === 2 && newStep === 3) {
            await this.enterStep3()
            this.pickPackShip.current_status = 'packing'
            this.pickPackShip.current_step = 3
            await this.updatePickPackShip()
          }
          this.step = newStep
        } else if (this.remainingSubOrders.length) {
          this.cancelPreparationsDialog = true
        } else {
          await this.closePickPackShip()
        }
      },
      async enterStep2() {
        const confirmPreparationSuccess = await this.confirmPreparations()
        if (confirmPreparationSuccess) {
          await this.createPickPackShip()
          this.$router.push({ path: '/bins/' + this.pickPackShip._id })
        }
      },
      async enterStep3() {
        let itemsToScan = this.pickPackShip?.items_to_scan
        // as the PPS has just been git , this.pickPackShip.items_to_scan is empty, but if it has been saved once during
        // step 2, this.pickPackShip.items_to_scan is filled
        if (!itemsToScan || (Array.isArray(itemsToScan) && itemsToScan.length === 0)) {
          itemsToScan = this.getItemsToScan()
        }
        for (let itemToScan of itemsToScan) {
          for (let computedSubOrder of this.subOrders) {
            let computedSubOrderItem = computedSubOrder.items.find(
              (item) =>
                itemToScan.order_id === computedSubOrder.order_id &&
                item.product_id === itemToScan.product_id &&
                item.item_id === itemToScan.item_id
            )
            if (computedSubOrderItem) {
              if (computedSubOrderItem.nb_scanned === undefined) {
                this.$set(computedSubOrderItem, 'nb_scanned', 0)
              }
              if (itemToScan.is_scanned) {
                computedSubOrderItem.nb_scanned++
              }
              this.reconcileProductPositions(computedSubOrderItem, itemToScan)
            }
          }
        }
        this.remainingSubOrders = this.computedSubOrders
        await this.getSettingsByCountry(this.currentStoreDetails?.address?.country_id)
      },
      getSumScannedItems(items) {
        let totalNbProduct = 0
        totalNbProduct += items.reduce((a, b) => a + b.nb_scanned, 0)
        return totalNbProduct
      },
      getSumTotalItems(items) {
        let totalNbProduct = 0
        totalNbProduct += items.reduce((a, b) => a + b.product_quantity, 0)
        return totalNbProduct
      },
      translateNonProcessingReasons(nonProcessingReasonsKey) {
        const nonProcessingReasons = [
          { text: this.$t('subOrder.userNotAllowedToUpdateResource'), value: 'user_not_allowed_to_update_resource' },
          { text: this.$t('subOrder.sourceLocationNotFound'), value: 'source_location_not_found' },
          { text: this.$t('subOrder.preparationOrderNotFound'), value: 'sub_order_not_found' },
          { text: this.$t('subOrder.subOrderIsAlreadyInFinalState'), value: 'sub_order_is_already_in_final_state' },
          { text: this.$t('subOrder.preparationTimeoutReached'), value: 'preparation_timeout_reached' },
          { text: this.$t('subOrder.subOrderHasWrongStatus'), value: 'sub_order_has_wrong_status' },
        ]
        const nonProcessingReason = nonProcessingReasons.find((reason) => reason.value === nonProcessingReasonsKey)
        return nonProcessingReason?.text || nonProcessingReasonsKey
      },
      openRedirectDialog(modalTitle, modalMessage, modalMessageBottom) {
        this.redirectDialogTitle = modalTitle || this.$t('subOrder.noPreparationRemains')
        this.redirectDialogMessage = modalMessage || this.$t('subOrder.noPreparationRemainsMessage')
        this.redirectDialogMessageBottom = modalMessageBottom
        this.redirectDialog = true
      },
      async confirmPreparations() {
        this.loadingBtn = true
        EventBus.$emit('displayGlobalOverlay', {
          display: true,
          message: this.$t('subOrder.processingPreparationOrders'),
        })
        let success = true
        let patchData = this.subOrders.map((subOrder) => {
          return {
            order_id: subOrder.order_id,
            current_status: 'confirmed',
            items: subOrder.items.map((item) => {
              return {
                product_id: item.product_id,
                item_id: item.item_id,
                current_status: 'validated',
                validated_quantity: item.product_quantity,
              }
            }),
          }
        })

        const patchSubOrderResponse = await this.patchSubOrders(patchData)
        if (patchSubOrderResponse === false) {
          this.redirectDialogTitle = this.$t('subOrder.anErrorOccurred')
          this.redirectDialogMessage = this.$t('subOrder.anErrorOccurredProcessingPreparationsMessage')
          this.redirectDialogMessageBottom = this.$t('subOrder.anErrorOccurredProcessingPreparationsMessageP2')
          this.redirectDialog = true
          success = false
        } else {
          if (
            patchSubOrderResponse?.notUpdatedSubOrders &&
            Object.keys(patchSubOrderResponse.notUpdatedSubOrders).length
          ) {
            this.openNotUpdatedSubOrdersDialog(
              Object.entries(patchSubOrderResponse.notUpdatedSubOrders),
              this.$t('subOrder.preparationOrdersNotProcessed'),
              this.$t('subOrder.preparationOrdersNotProcessedMessage')
            )
            const notUpdatedSubOrdersIds = Object.keys(patchSubOrderResponse.notUpdatedSubOrders)
            this.subOrders = this.subOrders.filter((subOrder) => !notUpdatedSubOrdersIds.includes(subOrder.order_id))
          }
          if (!this.subOrders.length) {
            this.openRedirectDialog()
            success = false
          }
        }
        EventBus.$emit('displayGlobalOverlay', { display: false })
        this.loadingBtn = false
        return success
      },
      async cancelRemainingPreparations() {
        this.loadingBtn = true
        this.closingPreparations = true
        EventBus.$emit('displayGlobalOverlay', {
          display: true,
          message: this.$t('subOrder.processingPreparationOrders'),
        })
        let patchData = this.remainingSubOrders.map((subOrder) => {
          const completion = this.getOrderCompletion(subOrder.items)
          const cancelReason = completion > 0 && completion < 1 ? 'partial_not_authorized' : 'no_product_validated'
          return {
            order_id: subOrder.order_id,
            current_status: 'cancelled',
            cancel_reason: cancelReason,
            items: subOrder.items.map((item) => {
              return {
                product_id: item.product_id,
                item_id: item.item_id,
                current_status: 'cancelled',
                validated_quantity: 0,
                selected_product_positions: item.selected_product_positions,
              }
            }),
          }
        })

        const patchSubOrderResponse = await this.patchSubOrders(patchData)
        this.selected = []
        EventBus.$emit('displayGlobalOverlay', { display: false })
        this.loadingBtn = false

        if (patchSubOrderResponse === false) {
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('subOrder.anErrorOccurredCancellingPreparationsMessage'),
            color: 'error',
          })
          return false
        } else if (
          patchSubOrderResponse?.notUpdatedSubOrders &&
          Object.keys(patchSubOrderResponse.notUpdatedSubOrders).length
        ) {
          this.openNotUpdatedSubOrdersDialog(
            Object.entries(patchSubOrderResponse.notUpdatedSubOrders),
            this.$t('subOrder.preparationOrdersNotProcessed'),
            this.$t('subOrder.preparationOrdersNotCancelledMessage')
          )
          return false
        } else {
          return true
        }
      },
      async patchSubOrders(patchData) {
        let path = '/v1/int/sub-orders/bulk'
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          body: patchData,
        }
        try {
          const patchSubOrdersResponse = await this.$Amplify.API.patch('sub-orders', path, myInit)
          EventBus.$emit('reLoadCounter')
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('subOrder.orderUpdated'),
            color: 'success',
          })
          return patchSubOrdersResponse
        } catch (e) {
          console.log(e)
          return false
        }
      },
      async closePickPackShip() {
        this.pickPackShip.current_status = 'finished'
        await this.updatePickPackShip()
        await this.$router.push({ path: '/sub-orders/waiting' })
      },
      async validatePreparationsCancellation() {
        const cancelRemainingPreparationsSuccess = await this.cancelRemainingPreparations()
        if (cancelRemainingPreparationsSuccess) {
          await this.closePickPackShip()
        }
      },
      reconcileProductPositions(computedSubOrderItem, itemToScan) {
        if (Array.isArray(computedSubOrderItem.selected_product_positions)) {
          // we try to match scanned items product positions which are split with computed subOrders ones
          if (computedSubOrderItem.selected_product_positions.length) {
            if (Array.isArray(itemToScan.selected_product_positions) && itemToScan.selected_product_positions.length) {
              for (let scannedPosition of itemToScan.selected_product_positions) {
                let computedItemPosition = computedSubOrderItem.selected_product_positions.find(
                  (matchingPosition) => matchingPosition.product_position_id === scannedPosition.product_position_id
                )
                if (computedItemPosition) {
                  computedItemPosition.taken_quantity += scannedPosition.taken_quantity
                } else {
                  computedSubOrderItem.selected_product_positions.push(JSON.parse(JSON.stringify(scannedPosition)))
                }
              }
            }
          } else {
            computedSubOrderItem.selected_product_positions = JSON.parse(
              JSON.stringify(itemToScan.selected_product_positions)
            )
          }
        }
      },
      deleteSubOrdersWithPreparationTimeoutReached() {
        let subOrdersWithReachedTimeout = this.subOrders
          .filter((subOrder) => {
            const remainingTime = subOrder.remainingTime
              ? subOrder.remainingTime
              : new Date(subOrder.date_limit_before_timeout) - new Date()
            return remainingTime <= 0 && !['waiting_carrier', 'to_pickup'].includes(subOrder.current_status)
          })
          .reduce((acc, subOrder) => {
            acc[subOrder.order_id] = 'preparation_timeout_reached'
            return acc
          }, {})
        const nbSubOrdersTimeout = Object.keys(subOrdersWithReachedTimeout).length
        if (nbSubOrdersTimeout) {
          const subOrdersWithReachedTimeoutIDs = Object.keys(subOrdersWithReachedTimeout)
          this.subOrders = this.subOrders.filter(
            (subOrder) => !subOrdersWithReachedTimeoutIDs.includes(subOrder.order_id)
          )
          // when we go from step 1 to step 2, we do not have this.pickPackShip set yet as it is created during the transition
          if (this.pickPackShip) {
            this.pickPackShip.items_to_scan = this.pickPackShip.items_to_scan.filter(
              (itemToScan) => !subOrdersWithReachedTimeoutIDs.includes(itemToScan.order_id)
            )
            this.pickPackShip.sub_orders = this.pickPackShip.sub_orders.filter(
              (subOrder) => !subOrdersWithReachedTimeoutIDs.includes(subOrder.order_id)
            )
          }
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('subOrder.preparationTimeoutReached'),
            color: 'error',
          })
        }
        if (!this.subOrders.length) {
          this.openRedirectDialog()
        }
        return subOrdersWithReachedTimeout
      },
      getOrderCompletion(items) {
        return this.getSumScannedItems(items) / this.getSumTotalItems(items)
      },
      updateRemainingSubOrders(value) {
        this.remainingSubOrders = value
      },
      handleNotUpdatedSubOrdersEvent(notUpdatedSubOrders) {
        this.openNotUpdatedSubOrdersDialog(
          notUpdatedSubOrders,
          this.$t('subOrder.preparationOrdersNotProcessed'),
          this.$t('subOrder.preparationOrdersNotProcessedMessage')
        )
      },
      openNotUpdatedSubOrdersDialog(notUpdatedSubOrders, modalTitle, modalMessage) {
        this.notUpdatedSubOrders = notUpdatedSubOrders
        this.notUpdatedSubOrdersDialogTitle = modalTitle
        this.notUpdatedSubOrdersDialogMessage = modalMessage
        this.notUpdatedSubOrdersDialog = true
      },
      async getSettingsByCountry(countryIso3) {
        // get the settings of the country selected
        EventBus.$emit('displayGlobalOverlay', {
          display: true,
          message: this.$t('subOrder.pleaseWait'),
        })
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
        }
        try {
          this.orderSettings = await this.$Amplify.API.get('settings', '/v1/settings/' + countryIso3, myInit)
        } catch (e) {
          // if settings are not found, and we did not try with 'FRA' which are considered as the country of the default settings
          // we try to get them with 'FRA'
          if (e.response?.status === 404 && countryIso3 !== 'FRA') {
            console.log(`No settings for country ${countryIso3}`)
            await this.getSettingsByCountry('FRA')
          }
        }
        EventBus.$emit('displayGlobalOverlay', {
          display: false,
        })
      },
      getTypeRequiringLockers() {
        if (this.orderSettings?.delivery?.locker?.for_preparation?.activate) {
          return this.orderSettings?.delivery?.locker?.for_preparation?.order_types || []
        }
        return []
      },
      async createPickPackShip() {
        EventBus.$emit('displayGlobalOverlay', {
          display: true,
          message: this.$t('subOrder.updatingPickPackShip'),
        })
        let data = {
          current_status: 'picking',
          current_step: 2,
          source_location_id: this.currentStore,
          sub_orders: this.computedSubOrders.map((subOrder) => {
            return {
              order_id: subOrder.order_id,
              bin_id: subOrder.binId,
            }
          }),
        }
        let path = '/v1/int/pick-pack-ships'
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          body: data,
        }
        try {
          this.pickPackShip = await this.$Amplify.API.post('pick-pack-ships', path, myInit)
          EventBus.$emit('reLoadCounter')
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('subOrder.pickPackShipCreated'),
            color: 'success',
          })
        } catch (e) {
          console.log(e)
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('subOrder.anErrorOccurredCreatingPickPackShip'),
            color: 'error',
          })
        }

        EventBus.$emit('displayGlobalOverlay', { display: false })
      },
      async getPickPackShip() {
        EventBus.$emit('displayGlobalOverlay', {
          display: true,
          message: this.$t('subOrder.getPickPackShipInProgress'),
        })
        let path = '/v1/int/pick-pack-ships/' + this.$route.params.id
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
        }
        try {
          this.pickPackShip = await this.$Amplify.API.get('pick-pack-ships', path, myInit)
          const subOrderIDs = this.pickPackShip.sub_orders.map((subOrder) => subOrder.order_id)
          if (!subOrderIDs.length) {
            this.openRedirectDialog()
          } else {
            await this.listSubOrders(subOrderIDs)
            if (this.pickPackShip.current_step > 1) {
              let subOrdersToDelete = {}
              let subOrdersInWrongStatus = {}

              const subOrdersWithReachedTimeout = this.deleteSubOrdersWithPreparationTimeoutReached()
              if (['picking', 'packing'].includes(this.pickPackShip.current_status)) {
                subOrdersInWrongStatus = this.deleteSubOrdersInWrongStatus(['confirmed'])
              }
              subOrdersToDelete = { ...subOrdersWithReachedTimeout, ...subOrdersInWrongStatus }
              if (Object.keys(subOrdersToDelete).length) {
                //as some order preparations has reached their preparation timeout, we need to delete them from the save PPS object in DB
                this.openNotUpdatedSubOrdersDialog(
                  Object.entries(subOrdersToDelete),
                  this.$t('subOrder.preparationOrdersNotProcessed'),
                  this.$t('subOrder.preparationOrdersNotProcessedMessage')
                )
                // we need to trigger an update of the pick pack ship to delete the required sub orders as long as there are still sub orders
                // if there are no more, the watch on this.subOrders will automatically cancel the pick pack ship and its empty sub_orders array property
                if (this.subOrders.length) {
                  await this.updatePickPackShip()
                }
              }
            }
            if (this.pickPackShip.current_step === 3) {
              await this.enterStep3()
            }
            this.step = this.pickPackShip.current_step
            EventBus.$emit('reLoadCounter')
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('subOrder.savedPickPackShipRetrieved'),
              color: 'success',
            })
          }
        } catch (e) {
          console.log(e)
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('subOrder.anErrorOccurredLoadingPickPackShip'),
            color: 'error',
          })
          await this.$router.push({ path: '/sub-orders/waiting' })
        }
        EventBus.$emit('displayGlobalOverlay', { display: false })
      },
      updateSubOrderLocker({ order_id, preparation_locker_id }) {
        const subOrder = this.pickPackShip.sub_orders.find((so) => so.order_id === order_id)
        if (subOrder) {
          this.$set(subOrder, 'preparation_locker_id', preparation_locker_id)
        }
      },
      async updatePickPackShip() {
        EventBus.$emit('displayGlobalOverlay', {
          display: true,
          message: this.$t('subOrder.updatingPickPackShip'),
        })
        let path = '/v1/int/pick-pack-ships/' + this.pickPackShip._id
        let updatedData = JSON.parse(JSON.stringify(this.pickPackShip))
        if (this.step === 2 && this.$refs?.step2) {
          // when we get items to scan from step 2 component, if any of the sub order has been deleted from this component,
          // because of time out for exemple, we must delete them as well in the pick pack ship before updating it
          const remainingSubOrderIds = this.subOrders.map((subOrder) => subOrder.order_id)
          updatedData.items_to_scan = this.getItemsToScan().filter((itemToScan) =>
            remainingSubOrderIds.includes(itemToScan.order_id)
          )
        }
        if (!this.subOrders.length) {
          updatedData.current_status = 'cancelled'
        }
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          body: updatedData,
        }
        try {
          this.pickPackShip = await this.$Amplify.API.put('pick-pack-ships', path, myInit)
          EventBus.$emit('reLoadCounter')
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('subOrder.pickPackShipUpdated'),
            color: 'success',
          })
        } catch (e) {
          console.log(e)
          return false
        }
        EventBus.$emit('displayGlobalOverlay', { display: false })
      },
      async listSubOrders(subOrdersIDs) {
        this.loadingData = true
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            page: 1,
            itemsPerPage: false,
          },
        }
        myInit.queryStringParameters.order_id = subOrdersIDs
        try {
          const res = await this.$Amplify.API.get('sub-orders', '/v1/int/sub-orders', myInit)
          if (Array.isArray(res?.data) && res.data.length) {
            this.subOrders = res.data
          } else {
            throw new Error('no_sub_orders_found_for_this_pick_pack_ship')
          }
        } catch (e) {
          this.loadingData = false
          console.log(e)
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('subOrder.anErrorOccurredLoadingOrderPreparations'),
            color: 'error',
          })
        }
      },
      deleteSubOrdersInWrongStatus(authorizedStatus = []) {
        let subOrdersWithWrongStatus = this.subOrders
          .filter((subOrder) => {
            return !authorizedStatus.includes(subOrder.current_status)
          })
          .reduce((acc, subOrder) => {
            acc[subOrder.order_id] = 'sub_order_has_wrong_status'
            return acc
          }, {})
        const nbSubOrdersWithWrongStatus = Object.keys(subOrdersWithWrongStatus).length
        if (nbSubOrdersWithWrongStatus) {
          const subOrdersWithWrongStatusIDs = Object.keys(subOrdersWithWrongStatus)
          this.subOrders = this.subOrders.filter((subOrder) => !subOrdersWithWrongStatusIDs.includes(subOrder.order_id))
          this.pickPackShip.items_to_scan = this.pickPackShip.items_to_scan.filter(
            (itemToScan) => !subOrdersWithWrongStatusIDs.includes(itemToScan.order_id)
          )
          this.pickPackShip.sub_orders = this.pickPackShip.sub_orders.filter(
            (subOrder) => !subOrdersWithWrongStatusIDs.includes(subOrder.order_id)
          )
          EventBus.$emit('displaySnackbar', {
            display: true,
            text: this.$t('subOrder.preparationTimeoutReached'),
            color: 'error',
          })
        }
        if (!this.subOrders.length) {
          this.openRedirectDialog()
        }
        return subOrdersWithWrongStatus
      },
    },
    watch: {
      async subOrders() {
        // if the pick pack ship is created and at any point there are no more sub orders in the preparation, we have to cancel the pick pack ship
        if (this.pickPackShip?._id && !this.subOrders.length) {
          await this.updatePickPackShip()
        }
      },
    },
  }
</script>
<style scoped>
  .retracted-bottom-button {
    margin-left: 330px;
    padding-right: 330px;
  }
  .bin-bottom-button {
    cursor: pointer;
  }
</style>
